var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 9.5,
    stroke: "#E9EAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3336 15.9999C14.3336 16.4419 14.5092 16.8659 14.8217 17.1784C15.1343 17.491 15.5582 17.6666 16.0002 17.6666C16.4423 17.6666 16.8662 17.491 17.1787 17.1784C17.4913 16.8659 17.6669 16.4419 17.6669 15.9999C17.6669 15.5579 17.4913 15.134 17.1787 14.8214C16.8662 14.5088 16.4423 14.3333 16.0002 14.3333C15.5582 14.3333 15.1343 14.5088 14.8217 14.8214C14.5092 15.134 14.3336 15.5579 14.3336 15.9999ZM14.3336 10.9999C14.3336 11.4419 14.5092 11.8659 14.8217 12.1784C15.1343 12.491 15.5582 12.6666 16.0002 12.6666C16.4423 12.6666 16.8662 12.491 17.1787 12.1784C17.4913 11.8659 17.6669 11.4419 17.6669 10.9999C17.6669 10.5579 17.4913 10.134 17.1787 9.82141C16.8662 9.50885 16.4423 9.33325 16.0002 9.33325C15.5582 9.33325 15.1343 9.50885 14.8217 9.82141C14.5092 10.134 14.3336 10.5579 14.3336 10.9999ZM14.3336 20.9999C14.3336 21.4419 14.5092 21.8659 14.8217 22.1784C15.1343 22.491 15.5582 22.6666 16.0002 22.6666C16.4423 22.6666 16.8662 22.491 17.1787 22.1784C17.4913 21.8659 17.6669 21.4419 17.6669 20.9999C17.6669 20.5579 17.4913 20.134 17.1787 19.8214C16.8662 19.5088 16.4423 19.3333 16.0002 19.3333C15.5582 19.3333 15.1343 19.5088 14.8217 19.8214C14.5092 20.134 14.3336 20.5579 14.3336 20.9999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsBtn);
export default __webpack_public_path__ + "static/media/dots-btn.29ed9362e60409851ec88eaf68652613.svg";
export { ForwardRef as ReactComponent };